module.exports = __webpack_public_path__ + "img/pro-photo8.109f83bd.png";